/// <amd-module name="VSS/Features/Search/SearchHeader/SearchHeader" />
import React = require("react");
import { IVssComponentContext, IVssComponentProperties, VssComponent } from "VSS/Platform/Layout";
import { ISearchQuery, IVssSearchService } from "VSS/Platform/Search";
import { SearchInputComponent } from "../SearchInput";

/**
 * The SearchHeaderInput is used to render the search input into the header.
 *
 * If the searchService has providers available on the page it will render the input
 * with the providers that have been defined.
 */
export class SearchHeaderInput extends VssComponent<IVssComponentProperties, {}> {
    private providersAvailable: boolean;

    public constructor(props: IVssComponentProperties, context: IVssComponentContext) {
        super(props, context);

        const searchService = context.pageContext.getService<IVssSearchService>("IVssSearchService");
        this.providersAvailable = Object.keys(searchService.getProviders()).length > 0;
    }

    public render(): JSX.Element | null {
        return this.providersAvailable ? (
            <div className="flex search-header">
                <SearchInputComponent
                    executeSearch={this.onExecuteSearch}
                    dropdownGapSize={0}
                    helpClassName="header-search-help"
                    showSearchProviders={true}
                    showSearchIcon={true}
                    spellCheck={false}
                />
            </div>
        ) : (
            <div className="search-placeholder" />
        );
    }

    public UNSAFE_componentWillReceiveProps(newProps: IVssComponentProperties): void {
        const searchService = this.context.pageContext.getService<IVssSearchService>("IVssSearchService");
        this.providersAvailable = Object.keys(searchService.getProviders()).length > 0;
    }

    private onExecuteSearch = (searchQuery: ISearchQuery): void => {
        const searchService = this.context.pageContext.getService<IVssSearchService>("IVssSearchService");
        searchService.execute(searchQuery);
    };
}

VssComponent.register("searchInput", SearchHeaderInput);
